import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'maps-home',
  templateUrl: './maps-home.component.html',
  styleUrls: ['./maps-home.component.less']
})
export class MapsHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/maps/maps-home.component.ts